import _ from 'lodash';

const asArray = val => {

    if (!val) {
        
        return [];
    }

    if (val.constructor !== Array) {
        
        return [val];
    }
    
    return val;
};

const sort = (arr) => {
    return (name) => {
        return (order) => {
            
            order = order ? order : 'asc';

            return _.orderBy(arr, [s => {
    
                if (typeof s[name] == 'string') {
                
                    return s[name].toLowerCase();
                }
    
                return s[name];            
                
            }], [order]);
        };
    };
};

const appendQueryString = (url) => {

    if (!url) {
            
        throw 'url is undefined';
    }

    return (key, val) => {
    
        if (!key || !val) {
            
            return url;
        }

        let newUrl = url, operand;

        operand = newUrl.indexOf('?') === -1 ? '?' : '&';

        newUrl = newUrl.concat(operand);
    
        if(url.toLowerCase().indexOf(key.toLowerCase()) === -1) {
        
            newUrl = `${newUrl}${key.toLowerCase()}=`;
        }
    
        const encodedVal = encodeURIComponent(val);

        return newUrl + encodedVal;
    };
};

export { asArray, appendQueryString, sort };


// WEBPACK FOOTER //
// ./src/services/utils/index.js